import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { API_URL } from './config';
import './index.css';

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser && token) {
      // Set user immediately from localStorage for fast initial load
      setUser(JSON.parse(savedUser));
      
      // Then fetch fresh data in background
      const fetchFreshUserData = async () => {
        try {
          const response = await axios.get(`${API_URL}/api/user/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          const freshUserData = response.data;
          setUser(freshUserData);
          localStorage.setItem('user', JSON.stringify(freshUserData));
        } catch (error) {
          console.error('Error fetching fresh user data on app load:', error);
          // If token is invalid, logout
          if (error.response?.status === 401 || error.response?.status === 403) {
            handleLogout();
          }
        }
      };
      
      fetchFreshUserData();
    }
  }, [token]);

  const handleLogin = async (userData, userToken) => {
    console.log('Login attempt with token:', userToken);
    console.log('Login attempt with user data:', userData);
    
    if (!userToken) {
      console.error('No token received from login');
      return;
    }
    
    setToken(userToken);
    localStorage.setItem('token', userToken);
    
    // Fetch fresh user data to get current balance
    try {
      const response = await axios.get(`${API_URL}/api/user/me`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      const freshUserData = response.data;
      setUser(freshUserData);
      localStorage.setItem('user', JSON.stringify(freshUserData));
    } catch (error) {
      console.error('Error fetching fresh user data:', error);
      // Fallback to login response data if API call fails
      const fallbackUser = {
        ...userData,
        patapizze: userData.patapizze || 0
      };
      setUser(fallbackUser);
      localStorage.setItem('user', JSON.stringify(userData));
    }
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/login" 
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/" 
            element={user ? (
              <Dashboard user={user} token={token} onLogout={handleLogout} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;